<template>
  <PmAppNotificationPure
    title="Kalendereintrag nicht sichtbar"
    variant="warning"
    :with-shadow="true"
    :can-be-closed="true"
    @close="emit('close')"
  >
    Ein Sprung zu {{ copy.label }} ist nicht möglich. {{ copy.subject }} wird
    vielleicht durch die Ansichtseinstellungen nicht angezeigt oder die
    entsprechende Gruppe ist eingeklappt.

    <template #actions>
      <PmButtonPure
        label="Alle Gruppen ausklappen"
        @click="emit('expandAllGroups')"
      />
      <PmButtonPure
        label="Ansichtseinstellungen öffnen"
        @click="emit('openViewSettings')"
      />
    </template>
  </PmAppNotificationPure>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CalendarJumpTargetType } from '@/composition/useCalendarJump'
import PmAppNotificationPure from '@/components/basics/PmAppNotification/PmAppNotificationPure.vue'
import PmButtonPure from '@/components/basics/PmButtonPure.vue'

export interface Props {
  targetType: CalendarJumpTargetType
}

const props = defineProps<Props>()

const emit = defineEmits<{
  close: []
  expandAllGroups: []
  openViewSettings: []
}>()

const copy = computed(() => {
  if (props.targetType === 'job') {
    return { label: 'diesem Job', subject: 'Der Job' }
  }

  if (props.targetType === 'project') {
    return { label: 'diesem Projekt', subject: 'Das Projekt' }
  }

  if (props.targetType === 'stockTypeService') {
    return { label: 'diesem Werkstattvorgang', subject: 'Der Werkstattvorgang' }
  }

  if (props.targetType === 'purchaseOrder') {
    return { label: 'dieser Bestellung', subject: 'Die Bestellung' }
  }

  return {
    label: 'dieser Ressourcen-Zuordnung',
    subject: 'Die Ressourcen-Zuordnung',
  }
})
</script>
